[
    "identity/users/edituser",
    "identity/roles/editrole",
    "identity/groups/editgroup",
    "identity/groups/creategroup",
    "identity/users/createuser",
    "identity/roles/createrole",
    "identity/companyaccessrestrictions/editcompanyaccessrestriction",
    "identity/companyaccessrestrictions/createcompanyaccessrestriction",
    "corepatterns/cultures/createculture",
    "corepatterns/cultures/editculture",
    "corepatterns/companies/editcompany",
    "corepatterns/companies/createcompany",
    "corepatterns/currencies/editcurrency",
    "corepatterns/currencies/createcurrency",
    "corepatterns/countries/editcountry",
    "corepatterns/countries/createcountry",
    "corepatterns/regions/editregion",
    "corepatterns/regions/createregion",
    "corepatterns/postalzones/editpostalzone",
    "corepatterns/postalzones/createpostalzone",
    "corepatterns/units/editunit",
    "corepatterns/units/createunit",
    "corepatterns/unitdimensions/editunitdimension",
    "corepatterns/unitdimensions/createunitdimension",
    "corepatterns/addresses/editaddress",
    "corepatterns/addresses/createaddress",
    "corepatterns/sequences/createstandardsequence",
    "corepatterns/sequences/editstandardsequence",
    "corepatterns/contacts/editcontact",
    "corepatterns/contacts/createcontact",
    "corepatterns/contacttypes/editcontacttype",
    "corepatterns/contacttypes/createcontacttype",
    "corepatterns/contactgroups/editcontactgroup",
    "corepatterns/contactgroups/createcontactgroup",
    "corepatterns/assignments/editassignment",
    "corepatterns/assignments/createassignment",
    "corepatterns/assignments/createsidebarassignment",
    "corepatterns/assignments/editsidebarassignment",
    "corepatterns/schemaentities/editcustomentity",
    "corepatterns/schemaentities/createcustomentity",
    "operations/notifications/createnotification",
    "operations/notifications/editnotification",
    "operations/emailtemplates/createemailtemplate",
    "operations/emailtemplates/editemailtemplate",
    "assetmanagementcore/locationfunctions/editlocationfunction",
    "assetmanagementcore/locationfunctions/createlocationfunction",
    "assetmanagementcore/locations/editlocation",
    "assetmanagementcore/locations/createlocation",
    "assetmanagementcore/criticalities/editcriticality",
    "assetmanagementcore/criticalities/createcriticality",
    "assetmanagementcore/equipmentitems/editequipmentitem",
    "assetmanagementcore/equipmentitems/createequipmentitem",
    "assetmanagementcore/routes/editroute",
    "assetmanagementcore/routes/createroute",
    "assetmanagementcore/meters/editmeter",
    "assetmanagementcore/meters/createmeter",
    "assetmanagementcore/propagatefamilycharacteristics/propagatefamilycharacteristics",
    "businesscore/series/createserie",
    "businesscore/parties/createpartybase",
    "businesscore/series/editserie",
    "businesscore/parties/editpartybase",
    "businesscore/exchangeratesdocuments/createexchangeratesdocument",
    "businesscore/exchangeratesdocuments/editexchangeratesdocument",
    "businesscore/brands/editbrand",
    "businesscore/brands/createbrand",
    "businesscore/brandmodels/editbrandmodel",
    "businesscore/brandmodels/createbrandmodel",
    "businesscore/families/editfamily",
    "businesscore/families/createfamily",
    "businesscore/parts/editpart",
    "businesscore/parts/createpart",
    "businesscore/pricelists/editpricelist",
    "businesscore/pricelists/createpricelist",
    "businesscore/dimensions/editdimension",
    "businesscore/dimensions/createdimension",
    "businesscore/partaccounttypes/editpartaccounttype",
    "businesscore/partaccounttypes/createpartaccounttype",
    "businesscore/partyaccounttypes/editpartyaccounttype",
    "businesscore/partyaccounttypes/createpartyaccounttype",
    "businesscore/customergroups/editcustomergroup",
    "businesscore/customergroups/createcustomergroup",
    "businesscore/suppliergroups/editsuppliergroup",
    "businesscore/suppliergroups/createsuppliergroup",
    "businesscore/dimensionvalues/editdimensionvalue",
    "businesscore/dimensionvalues/createdimensionvalue",
    "businesscore/vkentittystatetransitionhistories/editvkentittystatetransitionhistory",
    "businesscore/vkentittystatetransitionhistories/createvkentittystatetransitionhistory",
    "businesscore/vkschemaentitystates/editvkschemaentitystateresource",
    "businesscore/vkschemaentitystates/createvkschemaentitystateresource",
    "businesscore/dimensionsets/editdimensionset",
    "businesscore/purchasesparts/editpurchasespart",
    "businesscore/purchasesparts/createpurchasespart",
    "businesscore/statejustifications/editstatejustification",
    "businesscore/statejustifications/createstatejustification",
    "businesscore/statejustificationstypes/editstatejustificationtype",
    "businesscore/statejustificationstypes/createstatejustificationtype",
    "businesscore/characteristictypes/editcharacteristictype",
    "businesscore/characteristictypes/createcharacteristictype",
    "businesscore/characteristics/editcharacteristic",
    "businesscore/characteristics/createcharacteristic",
    "businesscore/calendareventkinds/editcalendareventkind",
    "businesscore/calendareventkinds/createcalendareventkind",
    "businesscore/workcalendars/editworkcalendar",
    "businesscore/workcalendars/createworkcalendar",
    "businesscore/worktimeschedules/editworktimeschedule",
    "businesscore/worktimeschedules/createworktimeschedule",
    "businesscore/customerparties/editcustomerparty",
    "businesscore/customerparties/createcustomerparty",
    "businesscore/supplierparties/editsupplierparty",
    "businesscore/supplierparties/createsupplierparty",
    "requests/requestreasons/editrequestreason",
    "requests/requestreasons/createrequestreason",
    "requests/requesttypes/editrequesttype",
    "requests/requesttypes/createrequesttype",
    "requests/requests/editrequest",
    "requests/requests/createrequest",
    "requests/requests/createrequestbymanager",
    "requests/requests/editrequestbymanager",
    "requests/requests/editrequestfromboard",
    "maintenancecore/maintenanceplantypes/editmaintenanceplantype",
    "maintenancecore/maintenanceplantypes/createmaintenanceplantype",
    "maintenancecore/maintenanceplans/editmaintenanceplanresource",
    "maintenancecore/maintenanceplans/createmaintenanceplanresource",
    "maintenancecore/prioritylevels/editprioritylevel",
    "maintenancecore/prioritylevels/createprioritylevel",
    "maintenancecore/workordertypes/editworkordertype",
    "maintenancecore/workordertypes/createworkordertype",
    "maintenancecore/activities/editactivity",
    "maintenancecore/activities/createactivity",
    "maintenancecore/misccosts/editmisccost",
    "maintenancecore/misccosts/createmisccost",
    "maintenancecore/verifications/editverification",
    "maintenancecore/verifications/createverification",
    "maintenancecore/misccoststypes/editmisccoststype",
    "maintenancecore/misccoststypes/createmisccoststype",
    "maintenancecore/verificationtypes/editverificationtype",
    "maintenancecore/verificationtypes/createverificationtype",
    "maintenancecore/failureactions/editfailureaction",
    "maintenancecore/failureactions/createfailureaction",
    "maintenancecore/failurecauses/editfailurecause",
    "maintenancecore/failurecauses/createfailurecause",
    "maintenancecore/failuresymptoms/editfailuresymptom",
    "maintenancecore/failuresymptoms/createfailuresymptom",
    "maintenancecore/operatingstates/editoperatingstate",
    "maintenancecore/operatingstates/createoperatingstate",
    "maintenancecore/workorderstates/editworkorderstate",
    "maintenancecore/workorderstates/createworkorderstate",
    "maintenancecore/requeststates/editrequeststate",
    "maintenancecore/requeststates/createrequeststate",
    "maintenancecore/familyfailuretypifications/editfamilyfailuretypification",
    "maintenancecore/familyfailuretypifications/createfamilyfailuretypification",
    "maintenancecore/maintenancenotifications/editmaintenancenotification",
    "maintenancecore/maintenancenotifications/createmaintenancenotification",
    "workshopscore/expertises/editexpertise",
    "workshopscore/expertises/createexpertise",
    "workshopscore/tiers/edittier",
    "workshopscore/tiers/createtier",
    "workshopscore/workshops/editworkshop",
    "workshopscore/workshops/createworkshop",
    "workshopscore/schedulinggroups/editschedulinggroup",
    "workshopscore/schedulinggroups/createschedulinggroup",
    "workshopscore/schedulinglaborcosts/editschedulinglaborcost",
    "workshopscore/schedulinglaborcosts/createschedulinglaborcost",
    "workshopscore/employees/editemployee",
    "workshopscore/employees/createemployee",
    "settings/accesslevels/editaccesslevel",
    "settings/accesslevels/createaccesslevel",
    "settings/deletedentities/editdeletedentity",
    "settings/deletedentities/createdeletedentity",
    "settings/labelconfigurations/editlabelconfiguration",
    "settings/labelconfigurations/createlabelconfiguration",
    "settings/analyticsdashboards/editanalyticsdashboard",
    "settings/analyticsdashboards/createanalyticsdashboard",
    "settings/assetgroups/editassetgroup",
    "settings/assetgroups/createassetgroup",
    "settings/mobilereports/editmobilereport",
    "settings/mobilereports/createmobilereport",
    "settings/customtags/editcustomtag",
    "settings/customtags/createcustomtag",
    "settings/inactiverecords/editinactiverecord",
    "settings/inactiverecords/createinactiverecord",
    "settings/assetrestrictions/editassetrestriction",
    "settings/assetrestrictions/createassetrestriction",
    "settings/companysettings/editcompanysetting",
    "settings/companysettings/createcompanysetting",
    "settings/warehouserestrictions/editwarehouserestriction",
    "settings/warehouserestrictions/createwarehouserestriction",
    "settings/inactiverecordsmanagements/inactiverecordsmanagement",
    "maintenance/workorders/editworkorderresource",
    "maintenance/workorders/createworkorderresource",
    "maintenance/workorderrequests/editworkorderrequest",
    "maintenance/workorderrequests/createworkorderrequest",
    "maintenance/workorderreportmisccosts/editworkorderreportmisccost",
    "maintenance/workorderreportmisccosts/createworkorderreportmisccost",
    "maintenance/workorderreportlabors/editworkorderreportlabor",
    "maintenance/workorderreportlabors/createworkorderreportlabor",
    "maintenance/workordertaskverifications/editworkordertaskverification",
    "maintenance/workordertaskverifications/createworkordertaskverification",
    "maintenance/workorderreportconsumptions/editworkorderreportconsumption",
    "maintenance/workorderreportconsumptions/createworkorderreportconsumption",
    "maintenance/workorderassignments/editworkorderassignment",
    "maintenance/workorderassignments/createworkorderassignment",
    "maintenance/failures/editfailure",
    "maintenance/failures/createfailure",
    "maintenance/preventivemaintenances/editpreventivemaintenance",
    "maintenance/preventivemaintenances/createpreventivemaintenance",
    "maintenance/preventivemaintenanceevents/editpreventivemaintenanceevent",
    "maintenance/preventivemaintenanceevents/createpreventivemaintenanceevent",
    "maintenance/previewpreventiveevents/editpreviewpreventiveevent",
    "maintenance/previewpreventiveevents/createpreviewpreventiveevent",
    "maintenance/operationalreports/editoperationalreport",
    "maintenance/operationalreports/createoperationalreport",
    "maintenance/vktransitionchanges/editvktransitionchange",
    "maintenance/vktransitionchanges/createvktransitionchange",
    "maintenance/workorders/createwoplannerresource",
    "maintenance/workorders/editwoplannerresource",
    "maintenance/preventivemaintenanceevents/editpreventivemaintenanceeventplanner",
    "maintenance/workorderrequests/createworkorderboardrequest",
    "maintenance/preventivemaintenancemanagements/prevmaintmanagement",
    "maintenance/womanagements/workordermanagement",
    "maintenance/preventivemaintenanceeventsmanagements/prevmainteventsmanagement",
    "maintenance/rqmanagements/requisitionmanagement",
    "maintenance/sparepartsmanagements/sparepartsmanagement",
    "maintenance/woassignmanagements/woassignmanagement",
    "maintenance/workordertaskverificationwos/editworkordertaskverificationwo",
    "maintenance/workordertaskverificationwos/editworkordertaskverificationboard",
    "inventorymanagement/adjustmentreasons/editadjustmentreason",
    "inventorymanagement/adjustmentreasons/createadjustmentreason",
    "inventorymanagement/stocktransferorders/editstandardstocktransferorder",
    "inventorymanagement/stocktransferorders/createstandardstocktransferorder",
    "inventorymanagement/partadjustments/editpartadjustmentview",
    "inventorymanagement/partadjustments/createpartadjustmentview",
    "inventorymanagement/partentries/createpartentrie",
    "inventorymanagement/partissues/editpartissue",
    "inventorymanagement/partissues/createpartissue",
    "inventorymanagement/partentries/editpartentrie",
    "inventorymanagement/semanagements/createstockentry",
    "inventorycore/inventorypostings/editinventoryposting",
    "inventorycore/inventorypostings/createinventoryposting",
    "inventorycore/warehouses/editwarehousesview",
    "inventorycore/warehouses/createwarehousesview",
    "inventorycore/partsubtypes/editpartsubtype",
    "inventorycore/partsubtypes/createpartsubtype",
    "inventorycore/inventorysetups/editinventorysetup",
    "inventorycore/inventorysetups/createinventorysetup",
    "inventorycore/documenttypes/editdocumenttype",
    "inventorycore/documenttypes/createdocumenttype",
    "inventorycore/warehouselocations/editwarehouselocation",
    "inventorycore/warehouselocations/createwarehouselocation",
    "inventorycore/inventoryparts/editinventorypartview",
    "inventorycore/inventoryparts/createinventorypartview",
    "inventorycore/classifyparts/classifyparts",
    "assetmanagement/workersconfigurations/editworkersconfiguration",
    "assetmanagement/workersconfigurations/createworkersconfiguration",
    "assetmanagement/assetlocationhistories/editassetlocationhistory",
    "assetmanagement/assetlocationhistories/createassetlocationhistory",
    "assetmanagement/locationparentlocationhistories/editlocationparentlocationhistory",
    "assetmanagement/locationparentlocationhistories/createlocationparentlocationhistory",
    "assetmanagement/downanduptimehistories/editdownanduptimehistory",
    "assetmanagement/downanduptimehistories/createdownanduptimehistory",
    "assetmanagement/downtimehistorytimes/editdowntimehistorytime",
    "assetmanagement/downtimehistorytimes/createdowntimehistorytime",
    "assetmanagement/assetinactivationhistorics/editassetinactivationhistoric",
    "assetmanagement/assetinactivationhistorics/createassetinactivationhistoric",
    "assetmanagement/monitorings/editmonitoring",
    "assetmanagement/monitorings/createmonitoring",
    "assetmanagement/metervalues/editmetervalue",
    "assetmanagement/metervalues/createmetervalue",
    "assetmanagement/monitoringvalues/editmonitoringvalue",
    "assetmanagement/monitoringvalues/createmonitoringvalue",
    "assetmanagement/wometerreadings/editwometerreading",
    "assetmanagement/wometerreadings/createwometerreading",
    "assetmanagement/womonitoringvalues/editwomonitoringvalue",
    "assetmanagement/womonitoringvalues/createwomonitoringvalue",
    "assetmanagement/parentequipmentchanges/editparentequipmentchange",
    "assetmanagement/parentequipmentchanges/createparentequipmentchange",
    "assetmanagement/metervaluereplacements/createmetervaluereplacements",
    "assetmanagement/metervaluereplacements/editmetervaluereplacements",
    "assetmanagement/equipmentreceptions/editequipmentreception",
    "assetmanagement/equipmentreceptions/createequipmentreception",
    "integration/pipelines/editpipelinescustom",
    "integration/pipelines/createpipelinescustom",
    "integration/integrationconfigs/editintegrationconfig",
    "integration/integrationconfigs/createintegrationconfig",
    "integration/pipelinesettings/editpipelinesetting",
    "integration/pipelinesettings/createpipelinesetting",
    "integration/integrationstatuses/editintegrationstatus",
    "integration/integrationstatuses/createintegrationstatus",
    "integration/integrationalerts/editintegrationalert",
    "integration/integrationalerts/createintegrationalert",
    "requisitionscore/requisitiontypes/editrequisitiontype",
    "requisitionscore/requisitiontypes/createrequisitiontype",
    "requisitionscore/requisitionstates/editrequisitionstate",
    "requisitionscore/requisitionstates/createrequisitionstate",
    "requisitions/requisitions/editrequisition",
    "requisitions/requisitions/createrequisition",
    "contractscore/contracttypes/editcontracttype",
    "contractscore/contracttypes/createcontracttype",
    "contractscore/contractstates/editcontractstate",
    "contractscore/contractstates/createcontractstate",
    "contracts/contracts/editcontract",
    "contracts/contracts/createcontract",
    "reporting/templateentitygroups/edittemplateentitygroup"
]
